<template>
    <div class="navigation">
        <div class="userInfo">
            <el-dropdown trigger="hover" @command="handleCommand">
                <span class="el-dropdown-link">
                    <i class="el-icon-user" style="margin-right: 5px;"></i>{{username}}<i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="clearfix" command="logout">
                        退出登录
                    </el-dropdown-item>
                    <el-dropdown-item class="clearfix" command="password">
                        修改密码
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <el-dialog :title="createdType == 'logout' ? '确认提醒' : '修改密码'" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
            <span v-if="createdType == 'logout'">是否确认退出登录？</span>
            <CustomForm v-else ref="CustomForm" :data="formData" @change="confirm" />
            <span slot="footer" v-if="createdType == 'logout'" class="dialog-footer" style="text-align:center;">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import CustomForm from "@/components/custom/CustomForm"
export default {
    components: { CustomForm },
    data() {
        return {
            username: "",
            createdType: "",
            formData: [
                { label: "旧密码", prop: "oldPassword", value: "", type: "password", required: true, span: 24 },
                { label: "新密码", prop: "password", value: "", type: "password", required: true, span: 24 },
                { label: "确认新密码", prop: "confirmPassword", value: "", type: "password", required: true, span: 24 },
            ],
            dialogVisible: false
        }
    },
    created() {
        const userInfo = JSON.parse(sessionStorage.getItem("admninUserInfo"))
        this.username = userInfo.name
    },
    methods: {
        handleCommand(command) {
            this.createdType = command
            this.dialogVisible = true
        },
        confirm(params) {
            switch (this.createdType) {
                case "logout":
                    this.dialogVisible = false
                    this.$https.get(this.$api.logout).then(res => {
                        this.$router.replace({
                            name: "login"
                        })
                    })
                    break;
                case "password":
                    if (!params) {
                        this.dialogVisible = false
                        return false
                    }
                    if (params.password != params.confirmPassword) {
                        this.$message.warning("两次输入密码不一样")
                        return false
                    }
                    this.$https.post(this.$api.changePassword, {
                        oldPassword: params.oldPassword,
                        password: params.password
                    }).then(res => {
                        this.$message.success("修改成功")
                        this.dialogVisible = false
                    })
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.navigation {
    position: absolute;
    left: 300px;
    right: 0;
    height: 50px;
    border-bottom: 1px solid #dedede;
    background: #fff;

    .userInfo {
        float: right;
        padding: 15px;
        cursor: pointer;
    }
}
</style>